/* The constants in this file are canonical identifiers for use with `Telemetry` timer metric methods.
 *
 * All timer metric identifiers should be written in `kebab-case`.
 */

/****************************/
/*** Patient Summarization ***/
/**************************/

/* The time between when the user initiates a summary generation and we show them the summary complete toast
 */
export const TIMER_PATIENT_SUMMARY_GENERATION_DURATION_IN_SECONDS =
  'patient-summary-generation-duration-in-seconds' as const;

/*****************************/
/*** Overlay Load Times    ***/
/*****************************/

/* The time between when a drawer is asked to open and when it has finished loading all of its
 * data — every `useCtwQuery` mounted by the drawer's content has produced its first data. The
 * clock starts at the `openResourceDrawer`/`openDrawer` call, so it covers the model fetch that
 * precedes the open when a drawer is opened by resource type and id.
 *
 * Every open emits exactly one vital, distinguished by its `loadStatus` context property:
 *  - `complete`:   the content settled (or was ready immediately, in which case the duration is
 *                  0 and `hadPendingLoads` is false — a fully cached open)
 *  - `abandoned`:  the drawer was closed before its content settled
 *  - `superseded`: a new open replaced the content before the previous one settled
 *
 * Also carried: `loadTrigger` (`user` | `deep-link` | `reload`, so that opens overlapping page
 * load can be segmented out of the headline metric), `overlayName`, `sawLoadError`, and the
 * drawer's resource type and id where it has one.
 */
export const TIMER_DRAWER_LOAD_TIME = 'drawer-load-time' as const;

/* The time between when a modal is asked to open and when it has finished loading all of its
 * data. Same contract as `TIMER_DRAWER_LOAD_TIME`, for modals instead of drawers.
 */
export const TIMER_MODAL_LOAD_TIME = 'modal-load-time' as const;

export type TimerMetricIdentifier =
  | typeof TIMER_PATIENT_SUMMARY_GENERATION_DURATION_IN_SECONDS
  | typeof TIMER_DRAWER_LOAD_TIME
  | typeof TIMER_MODAL_LOAD_TIME;
